import styled, { css } from 'styled-components';
import { lineHeight, theme, toRem } from 'design';

interface ModalTextProps {
  marginTop?: number;
  marginBottom?: number;
}

const ModalText = styled.p<ModalTextProps>`
  width: 100%;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  text-align: center;
  color: ${theme.color.neutral[800]};

  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${toRem(marginTop)};
    `}

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${toRem(marginBottom)};
    `}
`;

export default ModalText;
